import execVueLs from './modules/vue-ls';
import execAxios from './modules/axios';
import execCookies from './modules/vue-cookies';

export default () => {
  execVueLs();
  execAxios();
  execCookies();
};
